import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { UserBase } from "@core/models";
import { UserService } from "@core/services/user.service";
import { map, Observable } from "rxjs";

@Injectable()
export class UserInfoResolver implements Resolve<any> {
  private readonly userService = inject(UserService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserBase> {
    return this.userService.getUserInfo().pipe(
      map(response => response.data)
    );
  }
}
